import { useEffect, useState, useRef } from "react";
import { Button, Tooltip, Typography } from "antd";
import { ArrowRightOutlined, ArrowLeftOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import ContentSidebar from "./ContentSidebar";
// import VideoModal from "../../user/myCourses/UserVideoModal";
import UserVideoModal from "../../../pages/user/courses/UserVideoModal";
import UserPDFReaderModal from "../../user/myCourses/UserPDFReaderModal";
import "./ContentShowPage.css";
import { jwtDecode } from "jwt-decode";
import { markContentAsCompleted } from "../../../service/UserCourseService";
import Toast from "../../shared/toast/Toast";
import ConfirmDeletePopup from "../../shared/confirmDeletePopup/ConfirmDeletePopup";
const { Title } = Typography;

const ContentShowPage = ({
    selectedRecord,
    items,
    setShowContent,
    setSelectedRecord,
    courseId,
    loadCourseContent
}) => {
    const [viewerType, setViewerType] = useState("");
    const [viewerSrc, setViewerSrc] = useState("");
    const [viewerExtra, setViewerExtra] = useState("");
    const [visible, setVisible] = useState(true);
    const [isContentCompleted, setIsContentCompleted] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);
    const [isOpen, setIsOpen] = useState(false);
    const [pdfOpen , setPdfOpen] = useState(viewerType === "pdf" ? true : false);
    const userId = jwtDecode(localStorage.getItem("authtoken"))?.userId || localStorage.getItem("userId");

    const [itemIdChanged, setItemIdChanged] = useState(null);
    const videoModalRef = useRef(null);
    const pdfModalRef = useRef();

    const handleSidebarChange = async (newContentId) => {
        if (videoModalRef.current) {
            await videoModalRef.current.saveProgress();
        }
        if (pdfModalRef.current) {
            await pdfModalRef.current.saveProgress();
        }

        await loadCourseContent();

        setItemIdChanged(newContentId);
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 480);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getResourceType = (link) => {
        if (!link) return "unknown";
        const lower = link.toLowerCase();
        if (lower.includes("youtube.com") || lower.includes("youtu.be")) return "youtube";
        if (lower.endsWith(".mp4") || lower.endsWith(".mov")) return "video";
        if (lower.endsWith(".pdf")) return "pdf";
        if (lower.startsWith("http://") || lower.startsWith("https://")) return "website";
        return "unknown";
    };

    useEffect(() => {
        if (selectedRecord && selectedRecord.resourceLink) {
            console.log("Selected record changed:", selectedRecord);
            const resourceType = getResourceType(selectedRecord.resourceLink);
            console.log("Auto-starting content:", selectedRecord.title, "Type:", resourceType);

            setViewerExtra(selectedRecord.contentType || "");
            setIsContentCompleted(selectedRecord.acknowledged || false);

            if (resourceType === "youtube" || resourceType === "video") {
                setViewerType("video");
                setViewerSrc(selectedRecord.resourceLink);
            } else if (resourceType === "pdf") {
                setViewerType("pdf");
                setViewerSrc(selectedRecord.resourceLink);
            } else if (resourceType === "website") {
                window.open(selectedRecord.resourceLink, "_blank");
            } else {
                setViewerType(resourceType);
                setViewerSrc(selectedRecord.resourceLink);
            }
        }
    }, [selectedRecord]);

    const onPlayVideo = (src, type) => {
        setViewerType("video");
        setViewerSrc(src);
        setViewerExtra(type);
    };

    const onViewPDF = (src) => {
        setViewerType("pdf");
        setViewerSrc(src);
    };

    const closeViewer = () => {
};

    const closeContentViewer = () => {
        setShowContent(false);
        setSelectedRecord(null);
        loadCourseContent();
        setViewerType("");
        setViewerSrc("");
        setViewerExtra("");
    };

    const toggleSidebar = () => {
        setVisible(!visible);
    };

    const handleMarkAsDone = async () => {
        try {
            const data = await markContentAsCompleted(courseId, selectedRecord.contentId, userId);
            console.log("Content completion response:", data);

            if (data.acknowledged) {
                setIsContentCompleted(true);
                setSelectedRecord(prev => ({
                    ...prev,
                    acknowledged: true
                }));

                setToastType("success");
                setToastMessage(data.message);
                setShowToast(true);

                setTimeout(() => {
                    setShowToast(false);
                    loadCourseContent();
                }, 3000);

                console.log("Content marked as completed successfully!");
            } else {
                setToastType("error");
                setToastMessage("Failed to mark content as completed");
                setShowToast(true);

                setTimeout(() => {
                    setShowToast(false);
                }, 3000);
            }
        } catch (error) {
            console.error("Error marking content as done:", error);
            setToastType("error");
            setToastMessage("An error occurred while marking content as completed");
            setShowToast(true);

            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }
    };

    const renderActionButton = (item) => {
        const resourceType = getResourceType(item.resourceLink);
        if (resourceType === "youtube" || resourceType === "video") {
            return () => {
                onPlayVideo(item.resourceLink, item.contentType);
                setSelectedRecord(item);
            }
        }

        if (resourceType === "pdf") {
            return () => {
                onViewPDF(item.resourceLink);
                setSelectedRecord(item);
            }
        }
        if (resourceType === "website") {
            return () => {
                window.open(item.resourceLink, "_blank");
                setSelectedRecord(item);
            }
        }
        return () => { };
    };

    return (
        <div className="content-show-page">
            <div className="content-show-header">
                <div className="header-left">
                    {selectedRecord?.completionPercentage === 100 && <Tooltip title="Back to Course Content">
                        <Button
                            icon={<ArrowLeftOutlined style={{ fontSize: 20 }} />}
                            onClick={closeContentViewer}
                            className="back-btn"
                        />
                    </Tooltip>}

                    <Title
                        level={4}
                        style={{
                            margin: 0,
                            fontSize: "22px" // ADD: increase font size
                        }}
                    >
                        <Tooltip title={selectedRecord?.title}>
                            <span
                                style={{
                                    display: "inline-block",
                                    maxWidth: "500px",   // ADD: adjust as needed
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                }}
                            >
                                {selectedRecord?.title || "Course Content"}
                            </span>
                        </Tooltip>
                    </Title>


                </div>

                <div className="header-right">
                    {/* <Tooltip title={isContentCompleted ? "Marked completed" : "Mark as Done"}>
                        <Button
                            type={isContentCompleted ? "default" : "primary"}
                            icon={<CheckOutlined />}
                            onClick={handleMarkAsDone}
                            disabled={isContentCompleted}
                            className={`mark-done-btn ${isContentCompleted ? 'completed' : ''}`}
                            style={{
                                marginRight: 42,
                            }}
                        >
                            {selectedRecord?.acknowledged ? "Marked as done" : "Mark as Done"}
                        </Button>
                    </Tooltip> */}

                    <Tooltip title={visible ? "Hide" : "Show Content list"}>
                        <Button
                            // disabled={sidebarButtonDisable}
                            onClick={toggleSidebar}
                            className="content-sidebar-toggle-btn"
                        >
                            ☰
                        </Button>
                    </Tooltip>
                </div>
            </div>

            <div className={`contentuser-body ${visible ? 'sidebar-visible' : 'sidebar-hidden'}`}>
                <div className="viewer-container">
                    {viewerType === "video" && viewerSrc && (
                        <div className="video-modal-container">
                            <UserVideoModal
                                ref={videoModalRef}
                                isOpen={true}
                                fileName={viewerSrc}
                                resourceType={viewerType}
                                onClose={closeViewer}
                                contentId={selectedRecord?.contentId}
                                courseId={courseId}
                                userId={userId}
                                handleClose={closeContentViewer}
                                isAcknowledged={selectedRecord?.acknowledged || false}
                            />
                        </div>
                    )}

                    {viewerType === "pdf" && viewerSrc && (
                        <div className="pdf-modal-container">
                            <UserPDFReaderModal
                                ref={pdfModalRef}
                                key={selectedRecord?.contentId}
                                isOpen={true}
                                fileName={viewerSrc}
                                onClose={closeViewer}
                                contentId={selectedRecord?.contentId}
                                courseId={courseId}
                                userId={userId}
                                blockTime={selectedRecord?.completionPercentage > 95 ? 0 : 10}
                                isAcknowledged={selectedRecord?.acknowledged || false}
                                handleClose={closeContentViewer}
                            />
                        </div>
                    )}

                </div>

                {visible && (
                    <div className="contentuser-sidebar">
                        {/* Mobile close button */}
                        {isMobile && (
                            <Button
                                icon={<CloseOutlined />}
                                onClick={toggleSidebar}
                                className="mobile-sidebar-close"
                                size="small"
                            />
                        )}

                        <div className="sidebar-header">
                            Course Content
                        </div>
                        <div className="sidebar-content">
                            <ContentSidebar
                                items={items}
                                onPlayVideo={onPlayVideo}
                                onViewPDF={onViewPDF}
                                visible={true}
                                setViewerSrc={setViewerSrc}
                                setViewerExtra={setViewerExtra}
                                setViewerType={setViewerType}
                                setSelectedRecord={setSelectedRecord}
                                selectedRecord={selectedRecord}
                                renderActionButton={renderActionButton}
                                onChange={handleSidebarChange}
                            />
                        </div>
                    </div>
                )}
            </div>


            <Toast
                message={toastMessage}
                type={toastType}
                show={showToast}
                onClose={() => setShowToast(false)}
            />
        </div>
    );
};

export default ContentShowPage;